import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { di } from 'react-magnetic-di';
import { useExternalMessages } from '../../state';
export var useEditorViewHasInfos = function useEditorViewHasInfos() {
  var _useExternalMessages = useExternalMessages(),
    _useExternalMessages2 = _slicedToArray(_useExternalMessages, 1),
    externalInfos = _useExternalMessages2[0].infos;
  return externalInfos.length > 0;
};